import { Component, Input, OnInit } from '@angular/core';
import { BundleSet } from 'src/app/shared-core/models/checkout-data.model';

@Component({
  selector: 'checkout-cart-bundle-items',
  templateUrl: './cart-bundle-items.component.html',
  styleUrls: ['./cart-bundle-items.component.scss'],
})
export class CartBundleItemsComponent implements OnInit {
  @Input() BundleSet: BundleSet;
  constructor() { }
  ngOnInit(): void {

  }

  public getImageURL(imgURI: string) {
    if (!imgURI) return 'https://img.vistek.net/prodimg/200/blank.jpg?tr=w-75,h-75';
    return 'https://img.vistek.net' + imgURI[0];
  }

}
